"use strict";
/**
 * Simplified types for definition getters.
 * These expose only the commonly-used fields from the internal manifest types.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataType = void 0;
var dm_types_1 = require("../generated/dm-types");
Object.defineProperty(exports, "DataType", { enumerable: true, get: function () { return dm_types_1.DataType; } });
